import { useState } from 'react';
import moment from 'moment-jalaali';
import { Link } from 'react-router-dom';

export default function LatestReports({ reports }) {
  const [filter, setFilter] = useState('week');

  const today = moment().startOf('day');
  const weekStart = moment().startOf('week');

  const filtered = reports.filter((r) => {
    const d = moment(r.date);

    if (filter === 'today') return d.isAfter(today);
    if (filter === 'week') return d.isAfter(weekStart);
    return true; // all
  });

  return (
    <div className="bg-white p-4 shadow rounded-xl">
      <div className="flex gap-4 mb-4 border-b pb-2">
        <button
          className={filter === 'today' ? 'font-bold' : ''}
          onClick={() => setFilter('today')}>
          امروز
        </button>

        <button
          className={filter === 'week' ? 'font-bold' : ''}
          onClick={() => setFilter('week')}>
          این هفته
        </button>

        <button
          className={filter === 'all' ? 'font-bold' : ''}
          onClick={() => setFilter('all')}>
          همه
        </button>
      </div>

      <div className="space-y-4">
        {filtered.map((r) => (
          <ReportItem key={r._id} r={r} />
        ))}

        {!filtered.length && (
          <p className="text-gray-500 text-sm">هیچ گزارشی یافت نشد.</p>
        )}
      </div>
    </div>
  );
}

function ReportItem({ r }) {
  const user = r.user || {};
  const formatted = moment(r.date).format('jYYYY/jMM/jDD');

  return (
    <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl">
      <div className="flex items-center gap-3">
        <img
          src={user.photo || '/avatar.png'}
          className="w-10 h-10 rounded-full object-cover"
          alt=""
        />

        <div>
          <p className="font-bold">{user.name || 'کاربر ناشناس'}</p>
          <p className="text-sm text-gray-500">
            {r.type === 'weekly' ? 'گزارش هفتگی' : 'گزارش ماهانه'} • {formatted}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-4">
        {r.hasFeedback ? (
          <span className="px-3 py-1 text-sm bg-green-100 text-green-700 rounded-full">
            فیدبک داده شده
          </span>
        ) : (
          <span className="px-3 py-1 text-sm bg-yellow-100 text-yellow-700 rounded-full">
            منتظر فیدبک
          </span>
        )}

        <Link
          to={`/users/${r.userId}`}
          className="text-blue-600 hover:underline text-sm">
          مشاهده
        </Link>
      </div>
    </div>
  );
}
